import { ITheme } from "../../utils/theme";

export const LabelStyle = (theme: ITheme) => ({
  display: 'flex',
  alignItems: 'center'
});

export const BackIconStyle = (theme: ITheme) => ({
  position: 'relative',
  fontSize: '1.75rem',
  "& > path": {
    transform: "translateX(4px)"
  }
});

export const AvatarIconStyle = (theme: ITheme) => ({
  border: "1px solid",
  backgroundColor: theme.palette.corporateBlue,
  fontFamily: "ProximaNovaSemibold",
  fontSize: "16px",
});

export const BellIconStyle = (theme: ITheme) => ({
  p: 0,
  borderRadius: "50%",
  backgroundColor: theme.palette.corporateBlue,
  position: "absolute",
  right: "-12px",
  bottom: "-10px",
  "&:hover": {
    borderRadius: "50%",
    backgroundColor: theme.palette.corporateBlue,
  },
});

export const LogoStyle = (theme: ITheme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  '& > svg': {
    width: 'auto',
    height: '50px',
    maxHeight: '64px',
    fill: theme.palette.neutralWhite,
  },
});

export const AppBarStyle = {
  minHeight: '64px',
  justifyContent: 'center',
}
